var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ContentBox',{attrs:{"actions":_vm.actions,"size":{ height: '70vh' }}},[_c('template',{slot:"top"},[_c('Filters')],1),_c('div',{staticClass:"content"},[_c('Editor'),_c('ListTable')],1)],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }